import { WorkTimeTypeDescriptions, WorkTimeTypes } from '~modules/tabel/interfaces/work-time-types';

export type WorkTimeOption = {
	value: keyof typeof WorkTimeTypes;
	label: string;
};

export const workTimeOptions = Object.entries(WorkTimeTypes).map(([value, label]) => ({
	value: value as keyof typeof WorkTimeTypes,
	label: `${label} - ${WorkTimeTypeDescriptions[value as keyof typeof WorkTimeTypes]}`,
}));

export const getKeyByValue = (value: WorkTimeTypes): keyof typeof WorkTimeTypes | null => {
	const entry = Object.entries(WorkTimeTypes).find(([_, val]) => val === value);
	return entry ? (entry[0] as keyof typeof WorkTimeTypes) : null;
};

export const findOptionByValue = (enumValue: keyof typeof WorkTimeTypes): WorkTimeOption | null => {
	return workTimeOptions.find(option => option.value === enumValue) || null;
};
